import { TgIpType } from "../Projects/store/tg-projects-store.tsx";

export const canTgProjectGeneratePrefix = (ipType: TgIpType) => {
	// Generate Prefix using the generate prefix API only when IP type is Stylezed scene, defined character or object
	const generatePrefixActions = ["stylized_scene", "object_variants", "defined_character"];
	return generatePrefixActions.includes(ipType);
};
